import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestCallService } from '../services/rest-call.service';
import { MessageManagementService } from '../services/message-management.service';
import { IUserLogIn } from '../../auth/login/login.component';
import jwt_decode from 'jwt-decode';
import { IUserAuth } from '../data/IUserAuth';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { ISite } from '../data/ISite';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends RestCallService {

  constructor(
    public httpClient: HttpClient,
    public toastr: NbToastrService,
    public messageService: MessageManagementService,
    private router: Router
  ) {
    super(httpClient, toastr, messageService);
  }

  public login(user: IUserLogIn) {
    return this.post<string>('Authentication/Login', user);
  }

  public getSitesByUser(clientId: number, userName: string) {
    return this.get<ISite[]>('Authentication/GetSitesByUser/' + clientId + "/" + userName);
  }

  public generateAuthentication(token: string, clientName: string, siteName: string, clientCode: string, logo: string): void {
    sessionStorage.clear();

    var jwt = jwt_decode(token);

    sessionStorage.setItem("token", token);
    sessionStorage.setItem("expiration", jwt["exp"]);

    let user: IUserAuth = {
      id: jwt["Id"],
      name: jwt["given_name"],
      userName: jwt["unique_name"],
      email: jwt["email"],
      siteId: jwt["SiteId"],
      clientId: jwt["ClientId"],
      clientName: clientName,
      siteName: siteName,
      clientCode: clientCode,
      permission: JSON.parse(jwt["Permission"]),
      logo: logo
    }
    sessionStorage.setItem("user", JSON.stringify(user));
    this.router.navigate(['/adelita/dashboard']);
  }

  public getUser(): IUserAuth {
    return JSON.parse(sessionStorage.getItem("user"));
  }
}
